import React from "react";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

interface CompleteProfileFooterProps {
  children: React.ReactNode;
  buttonText: string;
  onClick: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  loadingText?: string;
  buttonIcon?: React.ReactNode;
  buttonVariant?: 'primary' | 'secondary';
}

const CompleteProfileFooter = ({
  children,
  buttonText,
  onClick,
  disabled = false,
  isLoading = false,
  loadingText = "Salvando...",
  buttonIcon,
  buttonVariant = 'primary',
}: CompleteProfileFooterProps) => {
  const buttonStyles = buttonVariant === 'primary'
    ? "bg-gradient-to-r from-[#C4406B] to-[#9F3764] hover:from-[#D4507B] hover:to-[#AF4774]"
    : "bg-purple-800 hover:bg-purple-700";

  return (
    <div className="flex flex-col min-h-[calc(100dvh-180px)]">
      {/* Content area - scrollable */}
      <div className="flex-1 overflow-y-auto scrollbar-none pb-4">
        {children}
      </div>
      
      {/* Sticky footer */}
      <div className="sticky bottom-0 left-0 right-0 pt-4 pb-24 md:pb-6 bg-gradient-to-t from-black via-black/95 to-transparent">
        <div className="max-w-3xl mx-auto px-4">
          <Button 
            onClick={onClick}
            disabled={disabled || isLoading}
            className={`w-full h-12 text-base font-medium text-white border-0 ${buttonStyles}`}
          >
            {isLoading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                {loadingText}
              </>
            ) : (
              <>
                {buttonText}
                {buttonIcon || <span className="ml-2">→</span>}
              </>
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CompleteProfileFooter;
